(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carnes-kar-collection-grid"] && !Shopify.designMode) return;
  try {
    
  class CkCollectionGrid extends HTMLElement {
    connectedCallback() {
      // orden: GET con recarga al cambiar
      const orden = this.querySelector('.ck-coll-grid__orden-select');
      if (orden) orden.addEventListener('change', () => orden.form.submit());
      // filtros: GET con recarga al marcar/desmarcar
      const filtros = this.querySelector('.ck-coll-grid__filtros');
      if (filtros) filtros.addEventListener('change', () => filtros.submit());
    }
  }
  customElements.define('ck-collection-grid', CkCollectionGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carnes-kar-contacto"] && !Shopify.designMode) return;
  try {
    
  // Anti doble envío v2 (28-ago): solo se bloquean CLICS del usuario (pointer-events por
  // clase), nunca el botón con `disabled` — deshabilitarlo puede cortar el re-envío
  // programático del captcha de Shopify. Se libera solo a los 8s por si el envío no llega
  // a navegar (p. ej. captcha estancado en tiendas con password — ver ledger §2b).
  (() => {
    const form = document.getElementById('CKContactForm');
    if (!form) return;
    const boton = form.querySelector('button[type="submit"]');
    if (!boton) return;
    const original = boton.textContent;
    form.addEventListener('submit', () => {
      if (boton.classList.contains('is-enviando')) return;
      boton.classList.add('is-enviando');
      boton.textContent = boton.dataset.textoEnviando || 'Enviando…';
      window.setTimeout(() => {
        boton.classList.remove('is-enviando');
        boton.textContent = original;
      }, 8000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carnes-kar-ofertas-countdown"] && !Shopify.designMode) return;
  try {
    
  class CkOfertasCountdown extends HTMLElement {
    connectedCallback() {
      // anclar a la zona horaria de la TIENDA (offset inyectado por Liquid, ej "-0400"),
      // no a la del navegador del visitante
      const tz = (this.dataset.tz || '').replace(/^([+-]\d{2})(\d{2})$/, '$1:$2');
      this.destino = new Date(this.dataset.fecha.replace(' ', 'T') + tz);
      if (isNaN(this.destino)) this.destino = new Date(this.dataset.fecha.replace(' ', 'T'));
      if (isNaN(this.destino)) { this.hidden = true; return; }
      this.spans = {
        dias: this.querySelector('[data-dias]'),
        horas: this.querySelector('[data-horas]'),
        minutos: this.querySelector('[data-minutos]'),
        segundos: this.querySelector('[data-segundos]'),
      };
      this.tick();
      this.intervalo = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.intervalo);
    }

    tick() {
      let resta = Math.floor((this.destino - Date.now()) / 1000);
      if (resta <= 0) {
        clearInterval(this.intervalo);
        if (this.hasAttribute('data-ocultar-al-vencer')) { this.hidden = true; return; }
        resta = 0;
      }
      const p = (n) => String(n).padStart(2, '0');
      this.spans.dias.textContent = p(Math.floor(resta / 86400));
      this.spans.horas.textContent = p(Math.floor((resta % 86400) / 3600));
      this.spans.minutos.textContent = p(Math.floor((resta % 3600) / 60));
      this.spans.segundos.textContent = p(resta % 60);
    }
  }
  customElements.define('ck-ofertas-countdown', CkOfertasCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carnes-kar-product"] && !Shopify.designMode) return;
  try {
    
  class CkProduct extends HTMLElement {
    connectedCallback() {
      this.imagen = this.querySelector('.ck-product__imagen');
      this.thumbs = [...this.querySelectorAll('.ck-product__thumb')];
      this.thumbs.forEach((t) => t.addEventListener('click', () => {
        if (!this.imagen) return;
        this.imagen.src = t.dataset.src;
        this.imagen.srcset = t.dataset.srcset;
        this.thumbs.forEach((x) => x.classList.remove('ck-product__thumb--activa'));
        t.classList.add('ck-product__thumb--activa');
      }));
    }
  }
  customElements.define('ck-product', CkProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carnes-kar-relacionados"] && !Shopify.designMode) return;
  try {
    
  class CkRelacionados extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cargado) return;
      fetch(this.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nuevo = doc.querySelector('ck-relacionados');
          if (nuevo && nuevo.innerHTML.trim()) {
            this.dataset.cargado = 'true';
            this.innerHTML = nuevo.innerHTML;
          }
        })
        .catch(() => {});
    }
  }
  customElements.define('ck-relacionados', CkRelacionados);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carnes-kar-sucursales-lista"] && !Shopify.designMode) return;
  try {
    
  class CkSucursalesLista extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.ck-sucursales-lista__input');
      this.cards = [...this.querySelectorAll('.ck-sucursales-lista__card')];
      this.iframe = this.querySelector('.ck-sucursales-lista__mapa-iframe');
      this.sinResultados = this.querySelector('.ck-sucursales-lista__sin-resultados');
      this.paradas = [...this.querySelectorAll('.ck-riel__parada')];
      this.fichas = [...this.querySelectorAll('.ck-riel__ficha')];

      if (this.input) this.input.addEventListener('input', () => this.filtrar());

      // Riel: cada parada es una ciudad. Sin JS quedan todas las fichas visibles
      // (peor, pero nunca vacío); acá se activa la ciudad de partida del mapa.
      this.paradas.forEach((parada) => {
        parada.addEventListener('click', () => this.elegirCiudad(parada.dataset.ciudad, true));
      });
      if (this.paradas.length) {
        const inicial = this.dataset.ciudadInicial || this.paradas[0].dataset.ciudad;
        const hay = this.paradas.some((p) => p.dataset.ciudad === inicial);
        this.elegirCiudad(hay ? inicial : this.paradas[0].dataset.ciudad, false);
      }
      // llegada desde la ficha de producto (CTA → /pages/sucursales#buscar): enfocar el buscador
      if (this.input && window.location.hash === '#buscar') this.input.focus();

      // Móvil compacto: 6 cards + botón "mostrar todas" (auditoría responsive 27-ago)
      this.verTodas = this.querySelector('.ck-sucursales-lista__ver-todas');
      if (this.verTodas) {
        if (window.matchMedia('(max-width: 749px)').matches && this.cards.length > 6) {
          this.classList.add('ck-sucursales-lista--compacta');
        }
        this.verTodas.addEventListener('click', () => {
          this.classList.remove('ck-sucursales-lista--compacta');
        });
      }

      // Revisión 27-ago: revelado tipo Figma + autocompletar + CTA de card al mapa
      this.sugerencias = this.querySelector('.ck-sucursales-lista__sugerencias');
      this.prepararReveal();
      this.prepararSugerencias();
      this.querySelectorAll('[data-cta-mapa]').forEach((cta) => {
        cta.addEventListener('click', (e) => {
          e.preventDefault();
          this.verEnMapa(cta.closest('.ck-sucursales-lista__card'));
        });
      });

      this.cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('.ck-sucursales-lista__card-cta, .ck-sucursales-lista__card-llegar')) return; // los CTA navegan, no cambian el mapa
          this.verEnMapa(card);
        });
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.verEnMapa(card);
          }
        });
      });
    }

    // El grid nace difuminado como el Figma (salvo la fila 1) y cada card se revela
    // rápido al entrar al viewport, en cascada. Buscar revela las coincidencias al tiro.
    prepararReveal() {
      const sinMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (sinMotion || !('IntersectionObserver' in window) || !this.cards.length) return;
      this.classList.add('ck-sucursales-lista--reveal');
      this.cards.slice(0, 4).forEach((c) => c.classList.add('is-revelada'));
      const io = new IntersectionObserver((entradas) => {
        entradas
          .filter((en) => en.isIntersecting)
          .forEach((en, i) => {
            window.setTimeout(() => en.target.classList.add('is-revelada'), i * 45);
            io.unobserve(en.target);
          });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.45 });
      this.cards.slice(4).forEach((c) => io.observe(c));
    }

    prepararSugerencias() {
      if (!this.input || !this.sugerencias) return;
      const mapa = new Map();
      this.cards.forEach((c) => {
        [c.dataset.ciudad, c.dataset.comuna].forEach((v) => {
          const texto = (v || '').trim();
          const clave = this.normalizar(texto);
          if (clave && !mapa.has(clave)) mapa.set(clave, texto);
        });
      });
      this.opciones = [...mapa.values()].sort((a, b) => a.localeCompare(b, 'es'));
      this.activa = -1;
      this.input.addEventListener('input', () => this.sugerir());
      this.input.addEventListener('keydown', (e) => this.teclasSugerencias(e));
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.ck-sucursales-lista__buscador-campo')) this.cerrarSugerencias();
      });
    }

    sugerir() {
      const q = this.normalizar(this.input.value.trim());
      if (q.length < 2) { this.cerrarSugerencias(); return; }
      const empiezan = this.opciones.filter((o) => this.normalizar(o).startsWith(q));
      const contienen = this.opciones.filter((o) => !this.normalizar(o).startsWith(q) && this.normalizar(o).includes(q));
      const lista = empiezan.concat(contienen).slice(0, 7);
      if (!lista.length) { this.cerrarSugerencias(); return; }
      this.sugerencias.textContent = '';
      lista.forEach((texto, i) => {
        const li = document.createElement('li');
        li.className = 'ck-sucursales-lista__sugerencia';
        li.id = 'ck-sug-' + i;
        li.setAttribute('role', 'option');
        const idx = this.normalizar(texto).indexOf(q);
        if (idx >= 0) {
          li.append(texto.slice(0, idx));
          const b = document.createElement('b');
          b.textContent = texto.slice(idx, idx + q.length);
          li.append(b, texto.slice(idx + q.length));
        } else {
          li.textContent = texto;
        }
        // mousedown (no click): se adelanta al blur del input
        li.addEventListener('mousedown', (e) => { e.preventDefault(); this.elegirSugerencia(texto); });
        this.sugerencias.append(li);
      });
      this.activa = -1;
      this.sugerencias.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    teclasSugerencias(e) {
      if (!this.sugerencias || this.sugerencias.hidden) return;
      const items = [...this.sugerencias.children];
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const paso = e.key === 'ArrowDown' ? 1 : -1;
        this.activa = (this.activa + paso + items.length) % items.length;
        items.forEach((li, i) => li.classList.toggle('is-activa', i === this.activa));
        this.input.setAttribute('aria-activedescendant', items[this.activa].id);
        items[this.activa].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.activa >= 0) {
        e.preventDefault();
        this.elegirSugerencia(items[this.activa].textContent);
      } else if (e.key === 'Escape') {
        this.cerrarSugerencias();
      }
    }

    elegirSugerencia(texto) {
      this.input.value = texto;
      this.cerrarSugerencias();
      this.filtrar();
      this.input.focus();
    }

    cerrarSugerencias() {
      if (!this.sugerencias) return;
      this.sugerencias.hidden = true;
      this.activa = -1;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }

    // resalta en el panel el local que está mostrando el iframe
    marcarLocal(embed) {
      this.querySelectorAll('.ck-riel__local').forEach((l) => {
        l.classList.toggle('ck-riel__local--activo', l.dataset.embed === embed);
      });
    }

    elegirCiudad(ciudad, mover) {
      if (!ciudad) return;
      this.paradas.forEach((p) => {
        p.setAttribute('aria-current', p.dataset.ciudad === ciudad ? 'true' : 'false');
      });
      this.fichas.forEach((f) => {
        f.hidden = f.dataset.ficha !== ciudad;
      });
      const activa = this.paradas.find((p) => p.dataset.ciudad === ciudad);
      if (activa && this.iframe && activa.dataset.embed) {
        this.iframe.src = activa.dataset.embed;
        this.marcarLocal(activa.dataset.embed);
      }
      if (mover) {
        // en móvil el riel va arriba del detalle: llevar la vista a la ficha
        const ficha = this.fichas.find((f) => f.dataset.ficha === ciudad);
        if (ficha && window.matchMedia('(max-width: 989px)').matches) {
          ficha.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }

    normalizar(txt) {
      return txt.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    filtrar() {
      const q = this.normalizar(this.input.value.trim());
      // buscar gana al modo compacto: las coincidencias se muestran aunque estén más allá de las 6
      if (q) this.classList.remove('ck-sucursales-lista--compacta');
      let visibles = 0;
      this.cards.forEach((card) => {
        const coincide = !q || this.normalizar(card.dataset.busqueda).includes(q);
        card.hidden = !coincide;
        if (coincide && q) card.classList.add('is-revelada'); // lo buscado se muestra nítido al tiro
        if (coincide) visibles++;
      });
      if (this.sinResultados) this.sinResultados.hidden = visibles > 0;
    }

    verEnMapa(card) {
      if (!this.iframe || !card.dataset.embed) return;
      this.cards.forEach((c) => c.classList.remove('ck-sucursales-lista__card--activa'));
      card.classList.add('ck-sucursales-lista__card--activa');
      // sincroniza el riel con la card elegida y deja el iframe en ESE local
      // (la parada apunta al primero de la ciudad, la card al suyo)
      if (card.dataset.ciudad) this.elegirCiudad(card.dataset.ciudad, false);
      this.iframe.src = card.dataset.embed;
      this.marcarLocal(card.dataset.embed);
      const riel = this.querySelector('.ck-riel') || this.iframe.closest('.ck-sucursales-lista__mapa');
      riel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  customElements.define('ck-sucursales-lista', CkSucursalesLista);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
